import User from "../Models/User";
import router from "@/Routes/router";
import {useMainStore} from "@/Stores/store";
import {logOut as apiLogOut} from "@/Services/auth";

export default () => {
    const user = new User();
    const $store = useMainStore();
    const logOut = async () => {
        console.log("logOut");
        await apiLogOut();
        sessionStorage.removeItem("user");
        $store.$reset();
        // $store.user.id = null;
        console.log($store);
        await router.push("/login");
    };

    return {
        user,
        logOut,
    };
};
